import axios from 'axios'
import { PriceQueryResult } from './oracle-client'

function getMap() {
  const map = new Map<string, string>()
  map.set('eth', 'ethereum')
  map.set('weth', 'ethereum')
  map.set('btc', 'bitcoin')
  map.set('wbtc', 'bitcoin')
  map.set('dai', 'dai')
  map.set('usdc', 'usd-coin')
  map.set('usdt', 'tether')
  map.set('matic', 'matic-network')

  return map
}

const map = getMap()

function getReverseMap() {
  const map = new Map<string, string>()
  map.set('ethereum', 'weth')
  map.set('bitcoin', 'wbtc')
  map.set('dai', 'dai')
  map.set('usd-coin', 'usdc')
  map.set('tether', 'usdt')
  map.set('matic-network', 'matic')

  return map
}

const reverseMap = getReverseMap()

function get(token: string): string {
  const val = map.get(token.toLowerCase())
  if (!val) {
    console.error('Oracle coingecko support cannot find token ', token)
    return token
  } else {
    return val
  }
}

function getReverse(token: string): string {
  const val = reverseMap.get(token.toLowerCase())
  if (!val) {
    console.error(
      'Oracle coingecko support cannot find reversed token for ',
      token
    )
    return token
  } else {
    return val
  }
}

export function coinGeckoUrl() {
  const supportedTokens = ['weth', 'wbtc', 'dai', 'matic', 'usdc']
  const quotes = supportedTokens
    .map(t => t.toLowerCase())
    .map(get)
    .join(',')
    .toLowerCase()

  const oracleEndpoint = 'https://api.coingecko.com/api/v3/simple/price'

  const url = `${oracleEndpoint}/?ids=${quotes}&vs_currencies=usd`
  return url
}

export async function coinGeckoCall(): Promise<PriceQueryResult[]> {
  const url = coinGeckoUrl()
  const data = (await axios.get(url)).data
  const result: PriceQueryResult[] = Object.entries(data).map(([k, v]) => {
    let price = v as { usd: number }
    return { symbol: getReverse(k).toUpperCase(), price: price.usd }
  })

  /**
   * Adding wmatic case
   */
  const wmaticPrice = result.find(
    p => p.symbol.toUpperCase() === 'MATIC'
  )!.price
  result.push({ symbol: 'WMATIC', price: wmaticPrice })
  return result
}
